import { batch } from 'react-redux'
import { customizeError, formatDNI } from '@chilecompra/react-kit'
import { makeActionCreator } from '../../config/store/utils'
import { getSiiInformation } from '../../services/sii'

export const GET_SII_INFORMATION = 'GET_SII_INFORMATION'
export const GET_SII_INFORMATION_ERROR = 'GET_SII_INFORMATION_ERROR'
export const GET_SII_INFORMATION_SUCCESS = 'GET_SII_INFORMATION_SUCCESS'
export const onGetSiiInformation = makeActionCreator(GET_SII_INFORMATION)
export const onGetSiiInformationError = makeActionCreator(GET_SII_INFORMATION_ERROR, 'payload')
export const onGetSiiInformationSuccess = makeActionCreator(GET_SII_INFORMATION_SUCCESS, 'payload')
export const onGetSiiInformationThunk =
  ({ dni, callback = () => undefined }) =>
  async (dispatch, getState) => {
    dispatch(onGetSiiInformation())

    try {
      const cleanDni = formatDNI(dni, 2)

      const { dni: siiInformationDni } = getState().siiInformation
      if (dni === siiInformationDni) {
        return batch(() => {
          dispatch(onGetSiiInformationSuccess())
          callback()
        })
      }

      const { data } = await getSiiInformation({
        actionType: GET_SII_INFORMATION,
        dni: cleanDni
      })

      if (!data?.payload?.estado) {
        throw customizeError({ originalError: null, code: 500, reason: 'SOMETHING_WENT_WRONG_ERROR' })
      }

      return batch(() => {
        dispatch(
          onGetSiiInformationSuccess({
            dni,
            businessActivities:
              data?.payload?.actividadEco?.actividadEconomica?.map(businessActivity => {
                // FIXME: https://github.com/babel/babel-eslint/issues/799
                const startDate =
                  businessActivity.fechainicio.substring(6, 10) +
                  '-' +
                  businessActivity.fechainicio.substring(3, 5) +
                  '-' +
                  businessActivity.fechainicio.substring(0, 2) +
                  'T00:00:00.000'
                return {
                  code: businessActivity.actividad,
                  description: businessActivity.descripcion,
                  startDate: new Date(startDate)
                }
              }) || []
          })
        )
        callback()
      })
    } catch (error) {
      // FIXME: this checks should goes inside the factoryService implementation.
      // It will be fixed in v2 of react-kit.
      if (error?.originalError?.code === 'ERR_CANCELED') {
        return
      }

      let reason
      switch (error.code) {
        case 401:
          reason = 'UNAUTHORIZED_ERROR'
          break
        case 404:
          reason = 'DNI_DOES_NOT_MATCH_ERROR'
          break
        default:
          reason = 'SOMETHING_WENT_WRONG_ERROR'
          break
      }

      return batch(() => {
        dispatch(
          onGetSiiInformationError({
            dni,
            error: customizeError({ originalError: error?.originalError, code: error.code, reason }).toObject()
          })
        )
        callback()
      })
    }
  }
